// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_PIP_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updatePipClaimPin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_PIP_PIN
});

export const updatePipClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_PIP_WORK_ORDER_ONE,
    workOrder
});

export const updatePipClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_PIP_WORK_ORDER_TWO,
    workOrder
});

export const updatePipClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_PIP_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_PIP_OWNERSHIP_STATUS
});

export const updatePipClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_PIP_FAILURE_PART
});

export const updatePipClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_PIP_FAILURE_DATE
});

export const updatePipClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_PIP_REPAIR_DATE
});

export const updatePipClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_PIP_USE_AMOUNT_UNIT,
    unitCollection
});

export const updatePipClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_PIP_USE_AMOUNT
});

export const updatePipClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_PIP_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetPipClaim = () => ({
    type: actions.RESET_CLAIM_PIP
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_PIP_STICKY_HEADER_VISIBILITY
        });

    };

export const updatePipProgram = pipProgram => ({
    pipProgram,
    type: actions.UPDATE_CLAIM_PIP_PIP_PROGRAM
});

export const validatePipNumber = pipNumber =>

    dispatch => {

        dispatch({
            property: 'pipNumber',
            type: actions.UPDATE_CLAIM_PIP_FORM_VALIDATION,
            validity: mapFormValidation('pipNumber', pipNumber)
        });

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/claim-details.js